import { useEffect, useState } from "react";
import { fmtClock, fmtCompact, fmtInt } from "../../game/format";

export function GoldenFrenzyToast({ amount, credits, frenzyEndsAt, onDone }: { amount: string; credits: string; frenzyEndsAt: number; onDone: () => void }) {
  const [now, setNow] = useState(0);
  useEffect(() => {
    setNow(Date.now());
    const t = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(t);
  }, []);
  const left = Math.max(0, frenzyEndsAt - now);
  useEffect(() => {
    if (left <= 0) onDone();
  }, [left, onDone]);
  return (
    <div className="bk-toast gold" role="status">
      🌟 +{fmtCompact(amount)} 🍪 +{fmtInt(credits)} ✨ · 5x frenzy {fmtClock(left)}
    </div>
  );
}
